export namespace UploadContentProgressActionsTypes {
  export const IN_PROGRESS = 'UPLOAD_CONTENT_IN_PROGRESS';
  export const COMPLETE = 'UPLOAD_CONTENT_COMPLETE';
  export const REMOVE_UPLOAD = 'REMOVE_CONTENT_UPLOAD';
}

export interface UploadContentInProgressAction {
  readonly type: typeof UploadContentProgressActionsTypes.IN_PROGRESS | typeof UploadContentProgressActionsTypes.COMPLETE;
  readonly id: string;
  readonly bytesUploaded?: number;
  readonly totalBytes?: number;
  readonly filename?: string;
}

export interface UploadContentRemoveAction {
  readonly type: typeof UploadContentProgressActionsTypes.REMOVE_UPLOAD;
  readonly id: string;
}

export type UploadContentProgressActions = UploadContentInProgressAction | UploadContentRemoveAction;

export function requestUploadContentInProgressAction(args: Omit<UploadContentInProgressAction, 'type'>): UploadContentInProgressAction {
  return {
    type: UploadContentProgressActionsTypes.IN_PROGRESS,
    ...args
  };
}

export function requestUploadContentCompleteAction(args: Omit<UploadContentInProgressAction, 'type'>): UploadContentInProgressAction {
  return {
    type: UploadContentProgressActionsTypes.COMPLETE,
    ...args
  };
}

export function removeUploadContentByIdAction(args: Omit<UploadContentRemoveAction, 'type'>): UploadContentRemoveAction {
  return {
    type: UploadContentProgressActionsTypes.REMOVE_UPLOAD,
    ...args
  };
}
